import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useConfig from "../../hooks/useConfig";
import { InfoRounded } from "@mui/icons-material";

// https://locusrobotics.atlassian.net/browse/HUB-2477
export const AnalyticsDisruptionBanner = () => {
  const theme = useTheme();
  const { navType } = useConfig();

  const bannerMessage = "We have identified the cause of increased dashboard sync delays at some sites. We expect affected sites to be back to real time by approximately 7:00 PM ET.";

  return (
    <Box
      id="globalAnalyticsDisruptionBanner"
      sx={{
        py: 1,
        pr: 1,
        mb: 1,
        backgroundColor: theme.palette.background.paper,
        display: "flex",

        color:
          navType === "dark"
            ? theme.palette.text.primary
            : theme.palette.text.primary
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "10px",
          marginLeft: "10px",
        }}
      >
        <InfoRounded stroke={1.5} size="20px" />
      </div>
      <Typography variant="subtitle1" color="inherit">
        {bannerMessage}
      </Typography>
    </Box>
  );
};
